import React, { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'
import { Typography, Grid } from '@material-ui/core/'
import { useDispatch, useSelector } from 'react-redux'
import c from 'classnames'
import { setStep3 } from '../../../../modules/story/actions'
import api from '../../../../api/stoty'
import { Button } from '../../../../components/UI'
import arrowCard from '../../../../assetss/img/arrowCard.svg'
import defaultBackPrev from '../../../../assetss/img/defaultBackPrev.svg'
import libraryIcon from '../../../../assetss/img/libraryIcon.svg'
import ImgsContainer from './components/index'
import moment from 'moment'
import './index.scss'

const Step4 = () => {
  const [imgId, setImgId] = useState('')
  const [srcImg, setSrcImg] = useState()
  const [open, setOpen] = useState(false)
  const [error, setError] = useState()
  const [storyImg, setStoryImg] = useState([])
  const history = useHistory()
  const dispatch = useDispatch()
  const { story } = useSelector(state => state)
  const { user } = useSelector(({ session }) => session)
  const { step3 } = useSelector(({ story }) => story)
  const [loading, setLoading] = useState(false)
  const [fullCount, setFullCount] = useState(0)
  const [skip, setSkip] = useState(0)

  const goTo = path => history.push(path)
  const onClose = () => setOpen(prev => !prev)

  const onNext = () => {
    if (!imgId) {
      setError('Please upload a picture from our gallery to complete your story. ')
      return
    }

    dispatch(setStep3({ src: srcImg, imageUuid: imgId }))
    goTo('/new-story/step/5')
  }

  useEffect(() => {
    window?.addEventListener('scroll', scrollHandler, true)
    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [])

  const scrollHandler = e => {
    if (e.target.scrollHeight - (e.target.scrollTop + window.innerHeight) < 100) {
      setLoading(true)
    }
  }

  useEffect(() => {
    if (loading && +storyImg?.length < +fullCount) {
      api.getStoryImg(20, skip + 20)
        .then(({ data }) => {
          setStoryImg([...storyImg, ...data?.images])
          setLoading(false)
        })
        .finally(() => {
          setLoading(false)
          setSkip(prev => prev + 20)
        })
    }
  }, [loading])

  useEffect(() => {
    api.getStoryImg(20, skip)
      .then(({ data }) => setStoryImg([...data?.images]))
  }, [])

  useEffect(() => {
    api.getStoryImageCount()
      .then(({ data }) => setFullCount(data?.count))
  }, [])

  useEffect(() => {
    if (step3?.src) {
      dispatch(setStep3({ src: step3?.src, imageUuid: step3?.imageUuid }))
      setImgId(step3?.imageUuid)
      setSrcImg(step3?.src)
    }
  }, [step3?.src])

  return (
    <Grid className='generalContainer'>
      <ImgsContainer
        imgs={storyImg}
        setImgId={setImgId}
        setSrcImg={setSrcImg}
        onClose={setOpen}
        open={open}
      />
      <Grid className='boxStep4'>
        <Typography className='stepTitle'>
          Almost done! <br />
          Upload a picture to illustrate your story.
        </Typography>
        <img
          src={srcImg}
          className='uploadCustomInput'
          id='contained-button-file'
          multiple
        />
        <label htmlFor='contained-button-file'>
          <Grid className='uploadBtn' onClick={onClose}>
            {srcImg ? (
              <img className={c('uploadImg', error && 'errorUploadBtn')} src={srcImg} />
            ) : (
              <Grid className={c('uploadImgDefault', error && 'errorUploadBtn')}>
                <img src={libraryIcon} className='uploadIconNewStory' />
                <Typography className='subTitle'>Tap here to open image library</Typography>
              </Grid>
            )}
          </Grid>
        </label>
        <div className='errorText'>{error}</div>
        <Grid className='btnStep'>
          <Button className='prevBtn' onClick={() => goTo('/new-story/step/3')}>
            Previous step
          </Button>
          <Button className='nextBtn' onClick={onNext}>
            Next step
          </Button>
        </Grid>
      </Grid>
      <Grid className='wrapperPreviewContainer'>
        <Grid className='previewContainer'>
          <Typography className='previewTitle'>Your story</Typography>
          <img className='previewArrow' src={arrowCard} alt='arrowCard' />
          <div className='backPreviewContainer'>
            <div className='widthPreviosImgBox'>
              <img className='widthPreviosImg' src={srcImg || defaultBackPrev} />
            </div>
            <Typography className='previewTitleCard'>{story?.step2?.title}</Typography>
            <Typography className='previewTextCard'>{story?.step1?.text}</Typography>
            <Typography className='previewHashtags'>{story?.step4?.hashtags}</Typography>
            <Typography className='previewDataPosted' align='center'>
              Posted on {moment()?.format('MMMM D, h:mm A')} {user?.user?.name ? user?.user?.name : 'Anonymous'}
            </Typography>
          </div>
          <Typography
            onClick={() => {
              goTo('/storyPrevios')
              dispatch(setStep3({ ...story?.step3, imageUuid: imgId }))
            }}
            className='linkPrevios'
          >
            Preview story
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

export default Step4
